<ug-alert></ug-alert>
<main>
    <header class="container-application" [class]="navbarBgClass">
      <sqep-header
        [helpUrl]="helpUrl()"
        [navbarBgClass]="navbarBgClass"
        [userUPN]="1234"
        [clientLogoAsset]="clientLogoAsset"
        [hideMenuToggle]="true"
      />
    </header>
    <mat-sidenav-container>
      <mat-sidenav
        [autoFocus]="'false'"
        opened
        mode="side"
        [fixedInViewport]="'fixed'"
        [style.width]="sidenavWidth"
        [style.margin-top.px]="67"
      >
        <sqep-custom-sidenav
          [heading]="clientHeading"
          [subTitle]="clientSubTitle"
          [clientLogoAsset2]="clientLogoAsset2"
          [collapsed]="collapsed()"
          [applicationName]="applicationName()"
          (changeCollapsedState)="collapsed.set(true)"
        />
      </mat-sidenav>

      <mat-sidenav-content class="content" [style.margin-left]="sidenavWidth">
        <div class="page">
          <router-outlet
            (activate)="onRouterOutletActivate($event)"
          ></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
</main>
  <sqep-footer
    [isSignedIn]="isSignedIn()"
    [navbarBgClass]="navbarBgClass"
    [appVersion]="appVersion()"
  />
